import React, { useState } from 'react'
import styled from "styled-components";
import RightNav from "./RightNav";

const StyledBurger = styled.div`
    width: 2rem;
    height: 2rem;
    top: 15px;
    right: 20px;
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
    color: #fff;
    z-index: 999;
    
    div{
        transition: all 0.3s linear;
        width: 2rem;
        height: 0.25rem;
        background-color: ${ ({open}) => open ? '#8E05C2' : '#700B97'};
        border-radius: 10px;
        transform-origin: 1px;

        &:nth-child(1){
            transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
        }
        &:nth-child(2){
            transform: ${({ open }) => open ? 'translateX(100%)' : 'translateX(0)'};
            opacity: ${({ open }) => open ? 0 : 1};
        }
        &:nth-child(3){
            transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
        }
    }


    @media (min-width: 768px) {
        display: none;
    }
`;

const Burger = () => {
    const [open, setOpen] = useState(false)

  return (
    <>    
        <StyledBurger open={open} onClick={() => setOpen(!open)}>
            <div />
            <div />
            <div />
        </StyledBurger>
        <RightNav open={open}/>
    </>
  )
}

export default Burger